import React from "react";
import {
  Card,
  Input,
  Radio,
  Popup,
  Icon,
} from "semantic-ui-react";
import { Label, Col, Row, CardBody, Button } from "reactstrap";
import Axios from "axios";
import { withNamespaces } from "react-i18next";
import "react-select/dist/react-select.css";
import "react-virtualized-select/styles.css";
import Select from "react-virtualized-select";
import Table from "../../../../Europartners/Components/Table";
import Authentication from "../../../../../services/Authentication";
import { Services } from "../../../../../repositories/clients/Services";
import { openNotification } from "../../../Components/Notification";

const auth = new Authentication();

function Calculadora(props) {
  let [isChecked, setIsChecked] = React.useState("aereo");
  let [longitudInput, setLongitudInput] = React.useState("");
  let [anchoInput, setAnchoInput] = React.useState("");
  let [alturaInput, setAlturaInput] = React.useState("");
  let [pesoInput, setPesoInput] = React.useState("");
  let [cbmInput, setCbmInput] = React.useState("");

  let [tipoContenedor, setTipoContenedor] = React.useState("");
  let [containerLabel, setContainerLabel] = React.useState("");

  let [cajasInput, setCajasInput] = React.useState("1");

  let [aereoCardResult, setAereoCardResult] = React.useState([]);
  let [terrestreCardResult, setTerrestreCardResult] = React.useState([]);

  let [aereoResult, setAereoResult] = React.useState([]);
  let [terrestreResult, setTerrestreResult] = React.useState([]);
  let [maritimoResult, setMaritimoResult] = React.useState([]);
  let [colorEnvelopAereo, setcolorEnvelopAereo] = React.useState("");
  let [colorEnvelopTerrestre, setcolorEnvelopTerrestre] = React.useState("");
  let [colorEnvelopMaritimo, setColorEnvelopMaritimo] = React.useState("");
  let [countAereo, setCountAereo] = React.useState(0);
  let [countTerrestre, setCountTerrestre] = React.useState(0);

  function Validator(params) {
    // return new RegExp(/^\d*\.?\d*$/).test(params)
    return new RegExp(
      /^(?:(0\.\d*)|([1-9]\.?\d*)|([1-9]*0*?\.\d*)|(0?\.?))$/
    ).test(params);
  }

  const handleChange = (value) => {
    setIsChecked(value);
    /* aereo */
    setLongitudInput("");
    setAnchoInput("");
    setAlturaInput("");
    setPesoInput("");
    setCajasInput("1");
  };

  const mCalcular = () => {
    if (isChecked === "aereo") {
      let pesoOb = {
        ind: countAereo,
        Dimensiones: `${longitudInput} x ${anchoInput} x ${alturaInput}`,
        Peso: pesoInput,
        Cajas: cajasInput,
        Volumen:
          ((longitudInput * anchoInput * alturaInput) / 1e6) * cajasInput,
        PesoTotal: pesoInput * cajasInput,
        PesoVolumetrico:
          (longitudInput * anchoInput * alturaInput * cajasInput) / 6000,
      };
      setCountAereo(countAereo + 1);
      setcolorEnvelopAereo("#0560FC");

      aereoResult.push(pesoOb);
      // setAereoResult([...aereoResult, pesoOb]);
      // aereoCardResult.push(pesoOb)
      buildCard();
    }

    if (isChecked === "terrestre") {
      let pesoOb = {
        ind: countTerrestre,
        Dimensiones: `${longitudInput} x ${anchoInput} x ${alturaInput}`,
        Peso: pesoInput,
        Cajas: cajasInput,
        Volumen:
          ((longitudInput * anchoInput * alturaInput) / 1e6) * cajasInput,
        PesoTotal: pesoInput * cajasInput,
        PesoVolumetrico:
          (longitudInput * anchoInput * alturaInput * cajasInput) / 3000,
      };
      setCountTerrestre(countTerrestre + 1);
      setcolorEnvelopTerrestre("#0560FC");

      terrestreResult.push(pesoOb);
      // setAereoResult([...aereoResult, pesoOb]);
      // aereoCardResult.push(pesoOb)
      buildCard();
    }

    if (isChecked === "maritimo") {
      setCountAereo(countAereo + 1);
      setContainerLabel(tipoContenedor.label);
      setColorEnvelopMaritimo("#0560FC");

      let noCajas;

      // la longitud el ancho y el largo esta dado en cm el resultado se
      // muestra en m3 por ello se divide entre 1e+6
      let dimensiones = longitudInput * anchoInput * alturaInput;
      let cbm = dimensiones / 1e6;
      let totalVolume = cbm * cajasInput;
      let pesoVolumetrico = (dimensiones * cajasInput) / 5000;
      let pesoTotal = pesoInput * cajasInput;

      if (tipoContenedor.value === "2stdr") {
        noCajas = Math.trunc(Math.round(1165 / 35.315 / cbm));
      }
      if (tipoContenedor.value === "4stdr") {
        noCajas = Math.trunc(Math.round(2350 / 35.315 / cbm));
      }
      if (tipoContenedor.value === "40hcd") {
        noCajas = Math.trunc(Math.round(2694 / 35.315 / cbm));
      }
      if (tipoContenedor.value === "45hcd") {
        noCajas = Math.trunc(Math.round(3043 / 35.315 / cbm));
      }

      let pesoOb = {
        ind: countAereo,
        Dimensiones: `${longitudInput} x ${anchoInput} x ${alturaInput}`,
        Cajas: cajasInput,
        CBM: cbm,
        VolumenTotal: totalVolume,
        PesoTotal: pesoTotal,
        PesoVolumetrico: pesoVolumetrico,
        totalCajas: noCajas,
      };

      // console.log(pesoOb);

      setCbmInput(pesoOb.CBM);

      if (containerLabel && tipoContenedor.label !== containerLabel) {
        setMaritimoResult([pesoOb]);
      } else {
        setMaritimoResult([...maritimoResult, pesoOb]);
        buildCard([...maritimoResult, pesoOb]);
      }
    }
  };

  function buildCard(params) {
    // console.log("terrestreResult-->", terrestreResult);
    console.log("param-->", params);
    console.log("isChecked", isChecked);
    if (params) {
      setAereoResult(params);
    }

    let cardResult = [];
    if (isChecked === "aereo") {
      params
        ? (cardResult = params.map((e, i) => {
          console.log("entre aqui");
          return (
            <div className="col-xs-12">
              <CardBody>
                <center>
                  <Row>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("dimensions")}
                      </div>
                      <div>{e.Dimensiones}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_volumen_m3")}
                      </div>
                      <div>{e.Volumen}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_weight_kg")}
                      </div>
                      <div>{e.PesoTotal}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("volumetric_weight_kg")}
                      </div>
                      <div>{e.PesoVolumetrico}</div>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col
                          md={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <span onClick={() => removeItem(e)} className='icon-delete icons-front-module card-report icon_query' />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </center>
                <hr></hr>
              </CardBody>
            </div>
          );
        }))
        : (cardResult = aereoResult.map((e, i) => {
          return (
            <div className="col-xs-12">
              <CardBody>
                <center>
                  <Row>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("dimensions")}
                      </div>
                      <div>{e.Dimensiones}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_volumen_m3")}
                      </div>
                      <div>{e.Volumen}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_weight_kg")}
                      </div>
                      <div>{e.PesoTotal}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("volumetric_weight_kg")}
                      </div>
                      <div>{e.PesoVolumetrico}</div>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col
                          md={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Icon
                            link
                            style={{ color: "red" }}
                            name="close"
                            onClick={() => removeItem(e)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </center>
                <hr></hr>
              </CardBody>
            </div>
          );
        }));
      setAereoCardResult(cardResult);
    } else if (isChecked === "terrestre") {
      params
        ? (cardResult = params.map((e, i) => {
          console.log("entre aqui");
          return (
            <div className="col-xs-12">
              <CardBody>
                <center>
                  <Row>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("dimensions")}
                      </div>
                      <div>{e.Dimensiones}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_volumen_m3")}
                      </div>
                      <div>{e.Volumen}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_weight_kg")}
                      </div>
                      <div>{e.PesoTotal}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("volumetric_weight_kg")}
                      </div>
                      <div>{e.PesoVolumetrico}</div>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col
                          md={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Icon
                            link
                            style={{ color: "red" }}
                            name="close"
                            onClick={() => removeItem(e)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </center>
                <hr></hr>
              </CardBody>
            </div>
          );
        }))
        : (cardResult = terrestreResult.map((e, i) => {
          console.log("estoy en el else");
          return (
            <div className="col-xs-12">
              <CardBody>
                <center>
                  <Row>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("dimensions")}
                      </div>
                      <div>{e.Dimensiones}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_volumen_m3")}
                      </div>
                      <div>{e.Volumen}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("total_weight_kg")}
                      </div>
                      <div>{e.PesoTotal}</div>
                    </Col>
                    <Col xs={12}>
                      <div className="calculadora-title">
                        {props.t("volumetric_weight_kg")}
                      </div>
                      <div>{e.PesoVolumetrico}</div>
                    </Col>
                    <Col xs={12}>
                      <Row>
                        <Col
                          md={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Icon
                            link
                            style={{ color: "red" }}
                            name="close"
                            onClick={() => removeItem(e)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </center>
                <hr></hr>
              </CardBody>
            </div>
          );
        }));
      setTerrestreCardResult(cardResult);
    } else {
      cardResult = params.map((e, i) => {
        return (
          <div className="col-xs-12">
            <CardBody>
              <center>
                <Row>
                  <Col xs={12}>
                    <div className="calculadora-title">
                      {props.t("dimensions")}
                    </div>
                    <div>{e.Dimensiones}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">{props.t("boxes")}</div>
                    <div>{e.Cajas}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">
                      {props.t("cbm_m3_2")}
                    </div>
                    <div>{e.CBM}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">
                      {props.t("total_volumen_m3")}
                    </div>
                    <div>{e.VolumenTotal}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">
                      {props.t("total_weight_kg")}
                    </div>
                    <div>{e.PesoTotal}</div>
                  </Col>
                  <Col xs={12}>
                    <div className="calculadora-title">
                      {props.t("volumetric_weight_kg")}
                    </div>
                    <div>{e.PesoVolumetrico}</div>
                  </Col>
                </Row>
              </center>
              <hr></hr>
            </CardBody>
          </div>
        );
      });
    }
  }

  const handleEraser = () => {
    setLongitudInput("");
    setAnchoInput("");
    setAlturaInput("");
    setPesoInput("");
    setCajasInput(1);
    setCbmInput("");
    setTipoContenedor("");

    // if (isChecked === "maritimo") {
    // setContainerLabel("");
    // setMaritimoResult([]);
    // setColorEnvelopMaritimo("");
    // }
  };

  const removeItem = (value) => {
    // console.log('aereoResult-->', aereoResult);
    // console.log("value", value);
    if (isChecked === "aereo") {
      let deleteItem = aereoResult.filter((item) => item.ind !== value.ind);
      // console.log("deleteItem-->", deleteItem);
      // aereoResult.push(deleteItem)
      setAereoResult(deleteItem);
      buildCard(deleteItem);
      if (aereoResult.length === 1) {
        setcolorEnvelopAereo("");
      }
    }
    if (isChecked === "terrestre") {
      console.log("terrestreResult-->", terrestreResult);
      let deleteItem = terrestreResult.filter((item) => item.ind !== value.ind);
      // console.log("deleteItem-->", deleteItem);
      // aereoResult.push(deleteItem)
      setTerrestreResult(deleteItem);
      buildCard(deleteItem);
      if (terrestreResult.length === 1) {
        setcolorEnvelopTerrestre("");
      }
    }

    if (isChecked === "maritimo") {
      let deleteItem = maritimoResult.filter((item) => item.ind !== value.ind);
      setMaritimoResult(deleteItem);
      if (maritimoResult.length === 1) {
        setColorEnvelopMaritimo("");
      }
    }
  };

  const columnsTable = [
    { label: props.t("dimensions"), key: "Dimensiones", position: "left" },
    {
      label: props.t("total_volumen_m3"),
      key: "Volumen",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "center",
    },
    {
      label: props.t("total_weight_kg"),
      key: "PesoTotal",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "right",
    },
    {
      label: props.t("boxes"),
      key: "Cajas",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "right",
    },
    {
      label: props.t("volumetric_weight_kg"),
      key: "PesoVolumetrico",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "left",
    },
    {
      label: "",
      key: "removeItem",
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12} style={{ display: "flex", alignItems: "center" }}>
              <span onClick={() => removeItem(value)} className='icon-delete icons-front-module card-report icon_query' />
            </Col>
          </Row>
        </Col>
      ),
    },
  ];

  const columnsTableTerrestre = [
    { label: props.t("dimensions"), key: "Dimensiones", position: "left" },
    {
      label: props.t("total_volumen_m3"),
      key: "Volumen",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "center",
    },
    {
      label: props.t("total_weight_kg"),
      key: "PesoTotal",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "right",
    },
    {
      label: props.t("boxes"),
      key: "Cajas",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "right",
    },
    {
      label: props.t("volumetric_weight_kg"),
      key: "PesoVolumetrico",
      idTh: "firstTh",
      idTd: "firstTd",
      position: "left",
    },
    {
      label: "",
      key: "removeItem",
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12} style={{ display: "flex", alignItems: "center" }}>
              <span onClick={() => removeItem(value)} className='icon-delete icons-front-module card-report icon_query' />
            </Col>
          </Row>
        </Col>
      ),
    },
  ];

  const tableMaritimo = [
    {
      label: props.t("dimensions"),
      key: "Dimensiones",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    { label: props.t("boxes"), key: "Cajas", idTh: "firstTh", idTd: "firstTd" },
    {
      label: props.t("cbm_m3_2"),
      key: "CBM",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    {
      label: props.t("total_volumen_m3"),
      key: "VolumenTotal",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    {
      label: props.t("total_weight_kg"),
      key: "PesoTotal",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    {
      label: props.t("volumetric_weight_kg"),
      key: "PesoVolumetrico",
      idTh: "firstTh",
      idTd: "firstTd",
    },
    // {
    //   label: "Numero de Cajas",
    //   key: "totalCajas",
    //   idTh: "firstTh",
    //   idTd: "firstTd",
    // },
    {
      label: "",
      key: "removeItem",
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12} style={{ display: "flex", alignItems: "center" }}>
              <span onClick={() => removeItem(value)} className='icon-delete icons-front-module card-report icon_query' />
            </Col>
          </Row>
        </Col>
      ),
    },
  ];

  const containerType = [
    { key: "2stdr", value: "2stdr", label: props.t("20_standard_dry") },
    { key: "4stdr", value: "4stdr", label: props.t("40_standard_dry") },
    { key: "40hcd", value: "40hcd", label: props.t("40_high_cube") },
    { key: "45hcd", value: "45hcd", label: props.t("45_high_cube") },
  ];

  const aereoInfo = `${props.t("subject_to_changes")}`;

  let colorEraser = longitudInput || anchoInput || alturaInput ? "#000a2e" : "";

  let cbmValue =
    longitudInput && anchoInput && alturaInput
      ? (longitudInput * anchoInput * alturaInput) / 1e6
      : "";

  const sendMail = (props) => {
    const dateNow = new Date();

    let dateString = `${dateNow.getFullYear() +
      "" +
      (dateNow.getMonth() + 1).toString().padStart(2, "0") +
      "" +
      dateNow.getDate().toString().padStart(2, "0")
      }.xlsx`;

    if (isChecked === "maritimo" && maritimoResult.length) {
      let correo = auth.getAuthentication("EmailUser");
      let objExce = {
        data: maritimoResult,
        info: {
          containerType: tipoContenedor.label,
          config: {
            //title:'Peso Volumétrico Áereo',
            headers: {
              containerType: props.t("container_type"),
            },
          },
        },
        options: {
          image: {
            name: "euro",
          },
          font: 'SF Pro Display',
          sheetName: props.t("volumetric_calc"),
          headers: [
            props.t("dimensions"),
            props.t("boxes"),
            props.t("cbm_m3_2"),
            props.t("total_volumen_m3"),
            props.t("total_weight_kg"),
            props.t("volumetric_weight"),
            props.t("amount_box"),
          ],
          keys: [
            "Dimensiones",
            "Cajas",
            "CBM",
            "VolumenTotal",
            "PesoTotal",
            "PesoVolumetrico",
            "totalCajas",
          ],
          font: 'SF Pro Display',
        },
        info: {
          config: {
            title: props.t("data_presented_excel"),
            titlePosition: {
              col: 2,
              row: 5,
            },
          },
        },
      };
      const url = `${Services.MAIL.path}send/calculadora-carga`;
      // const url = 'http://localhost:5017/send/calculadora-carga'

      Axios.post(url, {
        data: objExce,
        email: correo,
        name: `${props.t("volumetric_calc_sea")} - ` + dateString,
      });
    }

    if (isChecked === "aereo" && aereoResult.length) {
      let correo = auth.getAuthentication("EmailUser");
      let objExce = {
        data: aereoResult,
        // info:{
        //     config:{
        //       title:'Peso Volumétrico Áereo',
        //     }
        // },
        options: {
          image: {
            name: "euro",
          },
          sheetName: props.t("volumetric_calc"),
          headers: [
            props.t("dimensions"),
            props.t("weight_kg_2"),
            props.t("boxes"),
            props.t("total_volumen_m3"),
            props.t("total_weight_kg"),
            props.t("volumetric_weight_kg"),
          ],
          keys: [
            "Dimensiones",
            "Peso",
            "Cajas",
            "Volumen",
            "PesoTotal",
            "PesoVolumetrico",
          ],
          font: 'SF Pro Display',
        },
        info: {
          config: {
            title: props.t("data_presented_excel"),
            titlePosition: {
              col: 2,
              row: 5,
            },
          },
        },
      };
      // const url = 'http://localhost:5017/send/calculadora-carga'
      const url = `${Services.MAIL.path}send/calculadora-carga`;
      Axios.post(url, {
        data: objExce,
        email: correo,
        name: `${props.t("volumetric_calc_air")} - ` + dateString,
      });
    }

    if (isChecked === "terrestre" && terrestreResult.length) {
      let correo = auth.getAuthentication("EmailUser");
      let objExce = {
        data: terrestreResult,
        // info:{
        //     config:{
        //       title:'Peso Volumétrico Áereo',
        //     }
        // },
        options: {
          image: {
            name: "euro",
          },
          sheetName: props.t("volumetric_calc"),
          headers: [
            props.t("dimensions"),
            props.t("weight_kg_2"),
            props.t("boxes"),
            props.t("total_volumen_m3"),
            props.t("total_weight_kg"),
            props.t("volumetric_weight_kg"),
          ],
          keys: [
            "Dimensiones",
            "Peso",
            "Cajas",
            "Volumen",
            "PesoTotal",
            "PesoVolumetrico",
          ],
          font: 'SF Pro Display',
        },
        info: {
          config: {
            title: props.t("data_presented_excel"),
            titlePosition: {
              col: 2,
              row: 5,
            },
          },
        },
      };
      // const url = 'http://localhost:5017/send/calculadora-carga'
      const url = `${Services.MAIL.path}send/calculadora-carga`;
      Axios.post(url, {
        data: objExce,
        email: correo,
        name: `${props.t("volumetric_calc_road")} - ` + dateString,
      });
    }
    openNotification('success', props.t("result_send_tomail"));
  };

  const aereo = () => {
    return (
      <div className="row">
        <div className="col-12">
          {isChecked === "maritimo" ? (
            <>
              <div className="row">
                <div
                  className="col-4"
                  style={{ paddingRight: "0", textAlign: "left" }}
                >
                  <Label>{props.t("container_type")}</Label>
                </div>
                <div className="col-8">
                  <Select
                    placeholder={props.t("container_type")}
                    value={tipoContenedor}
                    onChange={(selectValue) => setTipoContenedor(selectValue)}
                    options={containerType}
                  />
                </div>
                {/* <div className="col-2">
                  <Label />
                </div> */}
              </div>
              <br />
            </>
          ) : (
            ""
          )}
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4">
              <Label>{props.t("length_cm")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={longitudInput}
                placeholder="0"
                // type="number"
                onChange={(e, { value }) => {
                  let res = Validator(value);
                  if (res) {
                    setLongitudInput(value);
                  }
                }}
              />
            </div>
            <div className="col-3">
              <Label>cm</Label>
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4" /* style={{padding:'0'}} */>
              <Label>{props.t("width_cm")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={anchoInput}
                placeholder="0"
                // type="number"
                // onChange={(e, { value }) => setAnchoInput(value)}
                onChange={(e, { value }) => {
                  let res = Validator(value);
                  if (res) {
                    setAnchoInput(value);
                  }
                }}
              />
            </div>
            <div className="col-3 col-md-3 col-lg-3">
              <Label>cm</Label>
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4">
              <Label>{props.t("height_cm")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={alturaInput}
                placeholder="0"
                // type="number"
                // onChange={(e, { value }) => setAlturaInput(value)}
                onChange={(e, { value }) => {
                  let res = Validator(value);
                  if (res) {
                    setAlturaInput(value);
                  }
                }}
              />
            </div>
            <div className="col-3 col-md-3 col-lg-3">
              <Label>cm</Label>
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4">
              <Label>{props.t("weight_kg")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={pesoInput}
                placeholder="0"
                // type="number"
                // onChange={(e, { value }) => setPesoInput(value)}
                onChange={(e, { value }) => {
                  let res = Validator(value);
                  if (res) {
                    setPesoInput(value);
                  }
                }}
              />
            </div>
            <div className="col-3 col-md-3 col-lg-3">
              <Label>kg</Label>
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-4">
              <Label>{props.t("boxes")}</Label>
            </div>
            <div className="col-5 col-md-5 col-lg-5 col-lg-5">
              <Input
                fluid
                value={cajasInput}
                // type="number"
                // onChange={(e, { value }) => setCajasInput(value)
                placeholder="0"
                onChange={(e, { value }) => {
                  let res = Validator(value);
                  if (res) {
                    setCajasInput(value);
                  }
                }}
              />
            </div>
            <div className="col-3 col-md-3 col-lg-3">
              <Label />
            </div>
          </div>
          <br />
          {isChecked === "maritimo" ? (
            <>
              <div className="row" style={{ alignItems: "center" }}>
                <div className="col-4">
                  <Label>{props.t("cbm_m3")}</Label>
                </div>
                <div className="col-5 col-md-5 col-lg-5 col-lg-5">
                  <Input
                    fluid
                    value={cbmValue}
                  //disabled
                  //onChange={(e, { value }) => (setCbmInput(value))}
                  />
                </div>
                <div className="col-3 col-md-3 col-lg-3">
                  <Label>m3</Label>
                </div>
              </div>
              <br />
            </>
          ) : (
            ""
          )}
          <div className="row" style={{ alignItems: "center" }}>
            <div
              className="col-3"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <span
                class="icon-clear icons-front-module"
                title={props.t("clear")}
                onClick={() => handleEraser()}
              />
            </div>
            <div className="col-7">
              {isChecked === "maritimo" ? (
                <Button
                  onClick={() => mCalcular(isChecked)}
                  disabled={
                    !(longitudInput && anchoInput && alturaInput) ||
                    maritimoResult.length >= 5 ||
                    !cajasInput ||
                    !tipoContenedor
                  }
                  color="primary"
                  className="custom-width-btn"
                >
                  {props.t("calculate")}
                </Button>
              ) : isChecked === "terrestre" ? (
                <Button
                  onClick={() => mCalcular(isChecked)}
                  disabled={
                    !(longitudInput && anchoInput && alturaInput) ||
                    terrestreResult.length >= 5
                  }
                  color="primary"
                  className="custom-width-btn"
                >
                  {props.t("calculate")}
                </Button>
              ) : (
                <Button
                  onClick={() => mCalcular(isChecked)}
                  disabled={
                    !(longitudInput && anchoInput && alturaInput) ||
                    aereoResult.length >= 5
                  }
                  color="primary"
                  className="custom-width-btn"
                >
                  {props.t("calculate")}
                </Button>
              )}
            </div>
            <div className="col-2" style={{ padding: "0" }}>
              <Popup
                content={aereoInfo}
                style={{ textAlign: "justify", fontSize: "12px" }}
                position="top center"
                wide="very"
                trigger={<em class="fa-1x icon-info mr-1"></em>}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <br />
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-xs-12 col-md-5 col-lg-5">
              <Card fluid style={{ backgroundColor: "#000a2e" }}>
                <Card.Content>
                  <Label style={{ font: "bold", color: "#fdfbfb" }}>
                    {props.t("volumetric_weight")}
                  </Label>
                </Card.Content>
              </Card>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          {/* <div className="row">
            <div className="col-12"> */}
          <Card fluid className="CARD UI REACT STRAP BORDER">
            <Card.Content>
              {/* Radio buttons */}
              <br />
              <div className="row">
                <CardBody>
                  <div className="col-xs-12 col-md-12 col-lg-12">
                    <div className="row">
                      <div className="col-xs-12 col-md-3 col-lg-3">
                        <div className="row">
                          <div className="col-2 d-flex align-items-center">
                            <Radio
                              //label='Áereo'
                              //value='aereo'
                              checked={isChecked === "aereo"}
                              onChange={() => {
                                handleChange("aereo");
                              }}
                            />
                          </div>
                          <div
                            className="col-4" /* style={{backgroundColor:'red'}} */
                          >
                            {/* <img
                                alt=""
                                src="https://fsposeidon.blob.core.windows.net/roldan/icon_avion.png"
                                width="35"
                              /> */}
                            <span className="icon-air-shipment icons-front-module" />
                          </div>
                          <div className="col-6 d-flex align-items-center">
                            <span>{props.t("air_freight")}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-3 col-lg-3">
                        <div className="row">
                          <div className="col-2 d-flex align-items-center">
                            <Radio
                              // label='Marítimo'
                              // value='maritimo'
                              checked={isChecked === "maritimo"}
                              onChange={() => {
                                handleChange("maritimo");
                              }}
                            />
                          </div>
                          <div
                            className="col-4" /* style={{backgroundColor:'red'}} */
                          >
                            {/* <img
                                alt=""
                                src="https://fsposeidon.blob.core.windows.net/roldan/icon_barco.png"
                                width="30"
                              /> */}
                            <span className="icon-sea-shipment icons-front-module" />
                          </div>
                          <div className="col-6 d-flex align-items-center">
                            <span>{props.t("ocean_freight")}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-xs-12 col-md-3 col-lg-3" /* style={{backgroundColor:'pink'}} */
                      >
                        <div className="row">
                          <div className="col-2 d-flex align-items-center">
                            <Radio
                              //label='Áereo'
                              //value='aereo'
                              checked={isChecked === "terrestre"}
                              onChange={() => {
                                handleChange("terrestre");
                              }}
                            />
                          </div>
                          <div
                            className="col-4" /* style={{backgroundColor:'red'}} */
                          >
                            {/* <img
                                alt=""
                                src="https://fsposeidon.blob.core.windows.net/roldan/icon_avion.png"
                                width="35"
                              /> */}
                            <span className="icon-ground-shipment icons-front-module" />
                          </div>
                          <div
                            className="col-6 d-flex align-items-center"
                          >
                            <span>{props.t("ground_freight")}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </div>
              <br />
              <div className="row">
                <div
                  className="col-xs-12 col-md-12 col-lg-12" /* style={{backgroundColor:'brown'}} */
                >
                  <div className="row">
                    <div
                      className={
                        "col-xs-12 col-md-12 col-lg-4"
                        /* isChecked === "aereo" ? "col-3" : "col-4" */
                      }
                    >
                      {aereo()}
                      <br></br>
                    </div>
                    <div
                      className={
                        "col-xs-12 col-md-12 col-lg-8"
                        /* isChecked === "aereo" ? "col-8" : "col-8" */
                      } /* style={{backgroundColor:'yellow'}} */
                    >
                      <Card fluid>
                        <Card.Content>
                          {isChecked === "maritimo" ? (
                            <div className="row">
                              <div className="col-12">
                                <CardBody>
                                  {/* <div className="row"> */}
                                  <Label
                                    className="colorPrimariLable"
                                  >
                                    <b className="colorPrimariLable">{props.t("container_type")}: </b>
                                  </Label>{" "}
                                  {containerLabel} {/* </div> */}
                                </CardBody>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <Table
                            columns={
                              isChecked === "aereo"
                                ? columnsTable
                                : isChecked === "terrestre"
                                  ? columnsTableTerrestre
                                  : tableMaritimo
                            }
                            data={
                              isChecked === "aereo"
                                ? aereoResult
                                : isChecked === "terrestre"
                                  ? terrestreResult
                                  : maritimoResult
                            }
                            options={{
                              large: true,
                              downloads: {
                                pdf: false,
                                xlsx: false,
                              },
                            }}
                          />

                          {/* {aereoCardResult} */}
                          <span
                            class="icon-email icons-front-module d-flex justify-content-end"
                            onClick={() => sendMail(props)}
                            title={props.t("send_email")}
                          />
                        </Card.Content>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Content>
          </Card>
          {/* </div>
          </div> */}
        </div>
      </div>
      <br />

      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <Card
                Card
                fluid
                header={
                  <span className="euro-title-form">
                    {props.t("total_weight_vol")}
                  </span>
                }
                style={{
                  textAlign: "justify",
                  fontSize: "12px",
                  color: "#000a2e",
                }}
                className="CARD UI REACT STRAP BORDER"
                description={
                  <div>
                    <p
                      style={{
                        textAlign: "justify",
                        fontSize: "12px",
                        fontSize: "12px",
                      }}
                    >
                      {props.t("total_weight_vol_desc_1")}
                    </p>
                    <p style={{ textAlign: "justify", fontSize: "12px" }}>
                      {props.t("total_weight_vol_desc_2")}
                    </p>
                    <p style={{ textAlign: "justify", fontSize: "12px" }}>
                      {props.t("total_weight_vol_desc_3")}
                      <b>
                        {props.t("total_weight_vol_desc_4")}{" "}
                        {isChecked === "aereo"
                          ? 6000
                          : isChecked === "terrestre"
                            ? 3000
                            : 5000}
                      </b>
                      .{" "}
                    </p>
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withNamespaces()(Calculadora);
